import { Injectable, inject } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermSheetDocMetaService {
  private wsService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'docmeta';
  wsManager = new WSEntityManager(this.wsService, this.entityName);

  subscribeDocMeta(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload, view: 'pln' }, true);
  }
}
